import { useTranslation } from 'react-i18next';
import { Badge } from '@aions/ui-primitives';

export type AiMode = 'simulated' | 'live';

/**
 * ADR-0007 — rótulo honesto enquanto a IA opera em modo simulado (MockAIClient,
 * pareceres por regra pré-definida). Renderiza um chip "IA SIMULADA" + nota
 * explicativa. Some sozinho quando aiMode === 'live' (chaves Anthropic
 * provisionadas, swap zero-edit no backend) — funciona em demo e em produção.
 *
 * O sinal vem do campo aditivo `aiMode` das respostas /parecer-ia e
 * /auditoria-status (isAIMocked() no repo-singleton).
 */
export function IaSimuladaBadge({ aiMode }: { aiMode?: AiMode | null }): JSX.Element | null {
  const { t } = useTranslation();
  if (aiMode !== 'simulated') return null;
  return (
    <span
      role="note"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        marginTop: 8,
      }}
    >
      <Badge tone="amber" solid>
        {t('ia_simulada.badge')}
      </Badge>
      <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
        {t('ia_simulada.note')}
      </span>
    </span>
  );
}
